import { router } from "@inertiajs/react"
import { useState } from "react"

import { readMessagesEnabled } from "@/components/agents/edit/receptionist/form-specs"
import { StepHeader, WizardLayout } from "@/components/agents/setup/shell"
import type { SetupStepProps } from "@/components/agents/setup/types"
import { YesNoCards } from "@/components/agents/setup/yes-no-cards"
import { Button } from "@/components/ui/button"
import { setupAgentPath } from "@/routes"

// IMP-461/492: the first decision — should the receptionist take messages?
//
// Stored as a plain boolean. Delivery isn't part of this choice: where a
// message goes is an account-level Notifications setting (IMP-375), and the old
// message_channel/message_destination pair conflated "can it take one" with
// "where does it go".
//
export function MessagesStep({
  agent,
  stepNumber,
  totalSteps,
}: SetupStepProps) {
  const [enabled, setEnabled] = useState(() =>
    readMessagesEnabled(agent.setup_data),
  )
  const [processing, setProcessing] = useState(false)

  function submit() {
    setProcessing(true)
    router.patch(
      setupAgentPath({ id: agent.uid }),
      {
        setup_step: "step-appointments",
        setup_data: { messages_enabled: enabled },
      },
      {
        preserveScroll: true,
        onFinish: () => setProcessing(false),
      },
    )
  }

  return (
    <WizardLayout
      footer={
        <Button onClick={submit} disabled={processing}>
          Continue
        </Button>
      }
    >
      <StepHeader
        eyebrow={`Step ${stepNumber} of ${totalSteps}`}
        title="Should I take messages?"
        description="When a call needs something only you can answer, I can take a message."
      />
      <YesNoCards
        yesLabel="Yes, take messages"
        yesSub="I'll take a message and send it to you."
        noLabel="No, don't take messages"
        // The one place "off" isn't a plain absence: PromptBuilder's
        // declined_messaging_section instructs the agent to say it can't take a
        // message and redirect the caller, so the card says that too.
        noSub="I'll tell callers I can't take messages and offer another contact option."
        value={enabled}
        onChange={setEnabled}
      />
    </WizardLayout>
  )
}
